/**
 * lib/storefront/wick_guide/base_wick.js
 */

class BaseWick {
  constructor(wickName, wickUrl) {
    this.name = wickName;
    this.url = wickUrl;
    this.multipleRows = false;
  }

  static get suffix() {
    return '';
  }

  get suffix() {
    return this.constructor.suffix;
  }

  get firstRow() {
    return this;
  }

  get secondRow() {
    return this;
  }
}

export default BaseWick;
